import React, { useState, useEffect, useRef } from 'react';
import { Paper, MenuItem } from '@mui/material';
import { ICoordinates } from '../../state/types';
import { useStyles } from './Themable.hooks';
import TranslationHelper from '../../helpers/TranslationHelper';

interface IOwnProps {
    position: ICoordinates | null;
    close: () => void;
    action: () => void;
    buttonText: string;
}
const initialState = {
    mouseX: null,
    mouseY: null,
};

const ContextMenu = ({ position, close, action, buttonText }: IOwnProps) => {
    const menuRef = useRef<HTMLDivElement>(null);
    const styles = useStyles();
    const [state, setState] = useState<{
        mouseX: null | number;
        mouseY: null | number;
    }>(initialState);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target as Node)
            ) {
                handleClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () =>
            document.removeEventListener('mousedown', handleClickOutside);
    }, [close]);

    useEffect(() => {
        if (position) {
            setState({
                mouseX: position.x + 10,
                mouseY: position.y - 20,
            });
        }
    }, [position]);

    const handleAction = () => {
        action();
        setState(initialState);
    };

    const handleClose = () => {
        close();
        setState(initialState);
    };

    if (!position) return null;

    return (
        <div
            ref={menuRef}
            style={{
                top: state.mouseY ?? undefined,
                left: state.mouseX ?? undefined,
            }}
            className={styles.popover}
        >
            <Paper
                elevation={0}
                style={{ backgroundColor: 'transparent', boxShadow: 'none' }}
            >
                <MenuItem
                    onClick={handleAction}
                    style={{ padding: '8px 16px' }}
                >
                    {TranslationHelper.translate(buttonText)}
                </MenuItem>
            </Paper>
        </div>
    );
};

export default ContextMenu;
